import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/bugsy.png'


const _hoisted_1 = ["dir"]
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex items-center justify-between h-16" }
const _hoisted_4 = { class: "flex items-center gap-3 min-w-0 flex-1 md:flex-initial" }
const _hoisted_5 = { class: "text-xl font-bold galaxy-text-gradient truncate" }
const _hoisted_6 = { class: "hidden md:flex items-center gap-6" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "header-actions relative z-[100] flex h-16 min-h-10 flex-shrink-0 items-center gap-2 self-stretch" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  class: "material-icons text-2xl",
  "aria-hidden": "true"
}
const _hoisted_11 = ["aria-label", "title"]
const _hoisted_12 = {
  key: 0,
  class: "md:hidden pb-4 space-y-1"
}
const _hoisted_13 = ["href"]

import { ref, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import HeroSection from '@/components/HeroSection.vue'
import AboutSection from '@/components/AboutSection.vue'
import CoursesSection from '@/components/CoursesSection.vue'
import RegistrationForm from '@/components/RegistrationForm.vue'
import FooterSection from '@/components/FooterSection.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t, locale } = useI18n()
const mobileMenu = ref(false)
const isDark = ref(false)

const navLinks = [
  { href: '#home', label: 'nav.home' },
  { href: '#about', label: 'nav.about' },
  { href: '#courses', label: 'nav.courses' },
  { href: '#register', label: 'nav.register' },
]

onMounted(() => {
  const saved = localStorage.getItem('theme')
  if (saved === 'dark' || (!saved && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    isDark.value = true
  }
  applyTheme()
  applyLocale()
})

watch(isDark, () => {
  applyTheme()
})

function applyTheme() {
  document.documentElement.classList.toggle('dark', isDark.value)
  document.body.classList.toggle('dark-body', isDark.value)
  localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
}

function toggleDarkMode() {
  isDark.value = !isDark.value
}

function applyLocale() {
  const dir = locale.value === 'ar' ? 'rtl' : 'ltr'
  document.body.dir = dir
  document.documentElement.lang = locale.value === 'ar' ? 'ar' : 'en'
}

function toggleLanguage() {
  locale.value = locale.value === 'en' ? 'ar' : 'en'
  localStorage.setItem('locale', locale.value)
  applyLocale()
}

watch(locale, () => {
  applyLocale()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    dir: _unref(locale) === 'ar' ? 'rtl' : 'ltr',
    class: _normalizeClass([
      _unref(locale) === 'ar' ? 'font-arabic' : 'font-english',
      isDark.value ? 'dark' : ''
    ])
  }, [
    _createElementVNode("nav", {
      class: _normalizeClass(["fixed top-0 left-0 right-0 z-50 overflow-visible transition-colors duration-300", isDark.value
        ? 'bg-space-900/90 backdrop-blur-xl border-b border-galaxy-700/30'
        : 'bg-white/90 backdrop-blur-xl border-b border-primary-100/50 shadow-sm'
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_0,
              alt: "Bugsy",
              class: "h-10 w-10 flex-shrink-0 object-contain drop-shadow-md transition-transform duration-300 hover:scale-110 hover:rotate-6"
            }, null, -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('nav.brand')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link) => {
              return _createElementVNode("a", {
                key: link.href,
                href: link.href,
                class: _normalizeClass(["font-medium transition-colors duration-200", isDark.value
                ? 'text-galaxy-200 hover:text-nebula-cyan'
                : 'text-gray-700 hover:text-primary-600'
              ])
              }, _toDisplayString(_unref(t)(link.label)), 11, _hoisted_7)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              "aria-label": isDark.value ? 'Light mode' : 'Dark mode',
              class: _normalizeClass(["header-action-btn flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2", isDark.value
                ? 'bg-white/15 text-amber-300 hover:bg-white/25 focus:ring-amber-400'
                : 'bg-violet-100 text-violet-700 hover:bg-violet-200 focus:ring-violet-500']),
              onClick: toggleDarkMode
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(isDark.value ? 'light_mode' : 'dark_mode'), 1)
            ], 10, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              "aria-label": _unref(t)('nav.languageAria'),
              title: _unref(t)('nav.language'),
              class: _normalizeClass(["header-action-btn flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2", isDark.value
                ? 'bg-white/15 text-cyan-300 hover:bg-white/25 focus:ring-cyan-400'
                : 'bg-violet-100 text-violet-700 hover:bg-violet-200 focus:ring-violet-500']),
              onClick: toggleLanguage
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", {
                class: "material-icons text-2xl",
                "aria-hidden": "true"
              }, "translate", -1)
            ]))], 10, _hoisted_11),
            _createElementVNode("button", {
              type: "button",
              "aria-label": "Menu",
              class: _normalizeClass(["header-action-btn md:hidden flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2", isDark.value
                ? 'bg-white/15 text-cyan-300 hover:bg-white/25 focus:ring-cyan-400'
                : 'bg-violet-100 text-violet-700 hover:bg-violet-200 focus:ring-violet-500']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenu.value = !mobileMenu.value))
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("span", {
                class: "material-icons text-2xl",
                "aria-hidden": "true"
              }, "menu", -1)
            ]))], 2)
          ])
        ]),
        (mobileMenu.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link) => {
                return _createElementVNode("a", {
                  key: link.href,
                  href: link.href,
                  class: _normalizeClass(["block px-3 py-2 rounded-lg transition-colors duration-200", isDark.value
              ? 'text-galaxy-200 hover:text-nebula-cyan hover:bg-galaxy-800/50'
              : 'text-gray-700 hover:text-primary-600 hover:bg-primary-100/60'
            ]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileMenu.value = false))
                }, _toDisplayString(_unref(t)(link.label)), 11, _hoisted_13)
              }), 64))
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("main", {
      class: _normalizeClass(["pt-16 transition-colors duration-300", isDark.value ? 'bg-space-900' : 'bg-violet-50/40'])
    }, [
      _createVNode(HeroSection, { "is-dark": isDark.value }, null, 8, ["is-dark"]),
      _createVNode(AboutSection, { "is-dark": isDark.value }, null, 8, ["is-dark"]),
      _createVNode(CoursesSection, { "is-dark": isDark.value }, null, 8, ["is-dark"]),
      _createVNode(RegistrationForm, { "is-dark": isDark.value }, null, 8, ["is-dark"])
    ], 2),
    _createVNode(FooterSection, { "is-dark": isDark.value }, null, 8, ["is-dark"])
  ], 10, _hoisted_1))
}
}

})